<template>
  <navbar position="fixed"
          type="primary"
          :transparent="transparent"
          :color-on-scroll="colorOnScroll"
          :menu-classes="'ml-auto ' + $route.name + '-navbar'"
  >
    <template slot-scope="{toggle, isToggled}">
      <img src="/images/logo-text-white-800-compressed.png" class="navbar-logo"/>
    </template>
    <template slot="before-menu" slot-scope="{toggle, isToggled}">
      <div class="d-flex d-sm-none navbar-logo-container">
        <img src="/images/logo-text-white-800-compressed.png" class="navbar-logo"/>
      </div>
    </template>
    <template slot="navbar-menu" v-if="$route.name !== 'menu'">
      <li class="nav-item">
        <a class="nav-link" href="" v-scroll-to="'#home'">
          <p>Home</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="" v-scroll-to="'#menu'">
          <p>Menu</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="" v-scroll-to="'#history'">
          <p>Notre histoire</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link btn btn-neutral text-left text-sm-center" href="https://book.osolemioliege.be">
          <p>Réserver</p>
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" rel="tooltip" title="Like us on Facebook" data-placement="bottom"
           href="https://www.facebook.com/osolemioliege/" target="_blank">
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" rel="tooltip" title="Follow us on Instagram" data-placement="bottom"
           href="https://www.instagram.com/o_solemioliege/" target="_blank">
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>

    </template>
  </navbar>
</template>

<script>
import {DropDown, Navbar, NavbarToggleButton, NavLink} from '@/components';
import {Popover} from 'element-ui';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  methods: {
  }
};
</script>

<style>
.navbar-logo {
  max-width: 200px;
}

.navbar-logo-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  padding: 0 15px;
}

@media screen and (max-width: 991px) {
  .sidebar-collapse .navbar .navbar-nav {
    margin-top: 0 !important;
  }
}

.menu-app .navbar-translate{
  margin: 0 auto !important;
  width: 100%;
  text-align: center;

  .navbar-logo{
    margin: 0 auto !important;
  }
}

</style>
